import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import configJson from './config.json';
const basePath=configJson["CommonConstants"]["Base_path"]

export const PrivateRoute = ({ component: Component, ...rest }) => (
    localStorage.getItem('user') 
        ? <Route {...rest} render={props => (
            <Component {...props} />
        )} />
    : <Redirect to={{ pathname: basePath+'/login' }} />
    
)


// WEBPACK FOOTER //
// ./src/_helpers/privateRoute.js